import * as React from "react";
import { useState, useEffect} from "react"
import ModernCard from "../core/ModernCard";
import NumberFormat from 'react-number-format';
import ProfitBar from "../core/ProfitBar";
import useQuote  from "../../hooks/useQuote";
import { jfetch } from "../../utils";
import { cwd } from "process";

//takes an array of strings, returns an array of numbers or false
function tryConvert(strArray){
  let itWorked = true;
  let numbers = []
  strArray.forEach(element => {
    const input = parseFloat(element);
    numbers.push(input)
    if(Number.isNaN(input)) {
      itWorked = false;
    }
  })
  return itWorked ? numbers : false 
}

function countActiveItems(items){
  let count = 0;
  items.forEach(item => {
    if(+item.qty > 0){
      count += 1;
    }
  })
  return count
}

interface IProps {
  disabled?:boolean;
  services:any;
  products:any;
  charges:any;
  productCategories:any;
  serviceCategories:any;
  chargeCategories:any;
  projectServiceCategories:any;
  updateService:Function;
  updateProduct:Function;
  updateCharge:Function;
  company:string;
  contact:string;
  email:string;
  notes:string;
  sold:boolean;
  isHAAS:boolean;
  setCompany:Function;
  setContact:Function;
  setEmail:Function;
  setNotes:Function;
  setSold:Function;
  setHAAS:Function;
  userContext:any;
  burdenRate:number;
  billRate:number;
  ROI:number;
  setBurdenRate:Function;
  setBillRate:Function;
  setROI:Function;
  contractTerm: number;
  setContractTerm: Function;
  setProjectHours?:Function;
  projectServices:any;
  updateProjectService:Function;
  projectHours:number;
  projectLaborRevenue:number;
  projectLaborExpense:number;
  servicesTotal:number;
  productsTotal:number;
  chargesTotal:number;
  chargesOnlyTotal:number;
  cwCompany?:number;
  cwId?:string;
}

function QuoteForm(props:IProps){
  const { 
    setAddingProduct, 
    setAddingService, 
    setAddingCharge,
    seeAllProducts,
    setSeeAllProducts,
    seeAllServices,
    setSeeAllServices,
    seeAllCharges,
    setSeeAllCharges,
    seeAllPServices,
    setSeeAllPServices,
    soldString, 
    setSoldString,
    hasCw,
    setCompanyModal,
    subtype,
    productExpense,
    serviceExpense,
    chargeExpense,
    projectLaborExpense,
    projectLaborRevenue,
    serviceHours,
    quoteSubmitted,
    setQuoteSubmitted,
    chargesOnlyExpense
  } = useQuote()
  const disabled = props.disabled == undefined ? false : props.disabled
  useEffect(() => {
    if(soldString == ''){
      props.setSold(null)
    }
    else{
      // 0 is false 1 is true. string -> int -> bool
      const bool_conversion = Boolean(+soldString)
      props.setSold(bool_conversion)
    }
  }, [soldString])
  return (
    <div className="col-lg-9">
      <h3>Details</h3>
      <div className="row details-row" style={{marginBottom:'26px'}}>
        <div className="col-lg-9">
          <ModernCard ta="left">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Company Name</label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={props.company}
                    onChange={(e) => props.setCompany(e.target.value)}
                    disabled={disabled}
                  />
                </div>
                <div className="form-group">
                  <label>Contact Name</label>
                  <input 
                    type="text"
                    className="form-control"
                    value={props.contact}
                    onChange={(e) => props.setContact(e.target.value)}
                    disabled={disabled}
                  />
                </div>
                <div className="form-group">
                  <label>Contact Email</label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={props.email}
                    onChange={(e) => props.setEmail(e.target.value)}
                    disabled={disabled}
                  />
                </div>
                <div className="form-group">
                  <label>ROI</label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={props.ROI}
                    onChange={(e) => props.setROI(e.target.value)}
                    disabled={disabled}
                  />
                </div>
                <div className="form-group">
                  <label>Contract Term</label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={props.contractTerm}
                    onChange={(e) => props.setContractTerm(e.target.value)}
                    disabled={disabled}
                  />
                </div> 
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>Burden Rate</label>
                      <NumberFormat
                        value={props.burdenRate}
                        displayType={'input'} 
                        fixedDecimalScale={true} 
                        decimalScale={2}
                        prefix={'$ '}
                        className='form-control'
                        onValueChange={(values) =>  props.setBurdenRate(values.value) }
                        thousandSeparator={true}
                      />                          
                    </div>
                    <div className="form-group">
                      <label>Billable Rate</label>
                      <NumberFormat
                        value={props.billRate}
                        displayType={'input'} 
                        fixedDecimalScale={true} 
                        decimalScale={2}
                        prefix={'$ '}
                        className='form-control'
                        onValueChange={(values) =>  props.setBillRate(values.value) }
                        thousandSeparator={true}
                      />   
                    </div>
                    <div className="form-group">
                      <label>Notes</label>
                      <textarea 
                        className="form-control" 
                        rows={4} placeholder="Enter notes here..."
                        value={props.notes}
                        onChange={(e) => props.setNotes(e.target.value)}
                        disabled={disabled}
                      >
                      </textarea>
                    </div>                    
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        {/* <input 
                          type="checkbox" 
                          checked={props.sold}
                          onChange={(event) => {
                            props.setSold(event.target.checked)
                          }}
                          style={{height:'inherit', marginRight:'10px'}}
                          disabled={disabled}
                        /> */}
                        Deal was Signed?
                      </label>
                      <select value={soldString} className="form-control" onChange={(e) => setSoldString(e.target.value)} disabled={disabled}>
                        <option value=''>Pending</option>
                        <option value='1'>Signed</option>
                        <option value='0'>Denied</option>
                      </select>
                    </div>
                  </div>                    
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <label style={{display:'flex'}}>
                      <input 
                        type="checkbox" 
                        checked={props.isHAAS}
                        onChange={(event) => {
                          props.setHAAS(event.target.checked)
                        }}
                        style={{height:'inherit', marginRight:'10px'}}
                        disabled={disabled}
                      />
                      Project Is HAAS
                    </label>
                  </div>                    
                </div>  
                <div className="row">
                  <div className="col-lg-12">
                    {hasCw && (subtype == 'edit') && (props.cwId == null) && (
                      <a onClick={() => setCompanyModal(true)} style={{cursor:'pointer'}}>Link a ConnectWise Company</a>
                    )}
                    {hasCw && (subtype == 'edit') && (props.cwId != null) && (
                      <p style={{color:'black'}}>
                        ConnectWise Company: <br/>
                        {props.cwCompany} 
                        <a style={{marginLeft:'5px', cursor:'pointer'}}>
                          <i className="fa fa-pencil" onClick={() => setCompanyModal(true)} />
                        </a>
                      </p>
                    )}
                    {hasCw && (subtype == 'show') && (props.cwId != null) && (
                      <p style={{color:'black'}}>
                        ConnectWise Company: <br/> {props.cwCompany} 
                      </p>
                    )}
                  </div>
                </div>              
              </div>
            </div>
          </ModernCard>
        </div>
      </div>     
      {/* Nav tabs */}
      <ul className="nav nav-tabs" role="tablist" style={{borderBottom:'none'}}>
        <li role="presentation" className="active">
          <a href="#services" aria-controls="services" role="tab" data-toggle="tab" style={{border:'none'}}>
            <h4>Monthly Services</h4>
          </a>
        </li>
        <li role="presentation">
          <a href="#products" aria-controls="products" role="tab" data-toggle="tab" style={{border:'none'}}>
            <h4>Monthly Products</h4>
          </a>
        </li>
        <li role="presentation">
          <a href="#charges" aria-controls="charges" role="tab" data-toggle="tab" style={{border:'none'}}>
            <h4>One-Time Project</h4>
          </a>
        </li>
        <li role="presentation">
          <a href="#projectlabor" aria-controls="projectlabor" role="tab" data-toggle="tab" style={{border:'none'}}>
            <h4>Project Labor</h4>
          </a>
        </li>        
      </ul>      

      {/* Tab panes */}
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" id="services">
          <div className="row">
            <div className="col-lg-12">
              <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                <div className="row" style={{paddingBottom:'15px'}}>
                  <div className="col-lg-6 text-left">
                    <a style={{cursor:'pointer'}} onClick={() => setSeeAllServices(!seeAllServices)} >
                      {seeAllServices ? 'Hide all' : 'Show all'}
                    </a>
                  </div>                    
                  <div className="col-lg-6 text-right">
                    <a style={{cursor:'pointer'}} onClick={() => setAddingService(true)} >Add Service</a>
                  </div>
                </div>
                <HeaderRow labels={['', '', 'Qty', 'Hours', 'Total']} />
                {props.serviceCategories && Object.entries(props.serviceCategories).map(([key, value]) => {
                  return (<ServiceCategory key={key} category={key} items={value} disabled={disabled} update={props.updateService} tryConvert={tryConvert} burdenRate={props.burdenRate} billRate={props.billRate} type="service" />)
                })}
                {/* {props.services.map((s) => <Service service={s} tryConvert={tryConvert} updateService={props.updateService} key={s.id} disabled={disabled} burdenRate={props.burdenRate} billRate={props.billRate} />)} */}
                <div className="row">
                  <div className="col-lg-12">
                    <hr style={{borderTop:'4px solid #e9edef', marginTop:'30px', marginBottom:'20px'}} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Sum Totals</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6"></div>
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Hours:</p>
                    <NumberFormat
                      value={serviceHours}
                      displayType='input'
                      disabled={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />
                  </div>                  
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Price:</p>
                    <NumberFormat
                      value={props.servicesTotal}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Cost:</p>
                    <NumberFormat
                      value={serviceExpense}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />                    
                  </div>
                </div>
              </ModernCard>
            </div>
          </div>          
        </div>
        <div role="tabpanel" className="tab-pane" id="products">
          <div className="row">
            <div className="col-lg-12">
              <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px" p="15px 18px 30px 18px">
                <div className="row" style={{paddingBottom:'15px'}}>
                  <div className="col-lg-6 text-left">
                    <a style={{cursor:'pointer'}} onClick={() => setSeeAllProducts(!seeAllProducts)} >
                      {seeAllProducts ? 'Hide all' : 'Show all'}
                    </a>
                  </div>                  
                  <div className="col-lg-6 text-right">
                    <a style={{cursor:'pointer'}} onClick={() => setAddingProduct(true)} >Add Product</a>
                  </div>
                </div>
                <HeaderRow labels={['', '', 'Qty', 'Cost', 'Sale Price', 'Total']} />
                {props.productCategories && Object.entries(props.productCategories).map(([key, value]) => {
                  return (<ProductCategory key={key} category={key} items={value} disabled={disabled} tryConvert={tryConvert} update={props.updateProduct} type="product" />)
                })}
                <div className="row">
                  <div className="col-lg-12">
                    <hr style={{borderTop:'4px solid #e9edef', marginTop:'30px', marginBottom:'20px'}} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Sum Totals</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-10"></div>                
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Price:</p>
                    <NumberFormat
                      value={props.productsTotal}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Cost:</p>
                    <NumberFormat
                      value={productExpense}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />                    
                  </div>
                </div>
              </ModernCard>
            </div>
          </div>          
        </div>
        <div role="tabpanel" className="tab-pane" id="charges">
          <div className="row">
            <div className="col-lg-12">
              <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                <div className="row" style={{paddingBottom:'15px'}}>
                  <div className="col-lg-6 text-left">
                    <a style={{cursor:'pointer'}} onClick={() => setSeeAllCharges(!seeAllCharges)} >
                      {seeAllCharges ? 'Hide all' : 'Show all'}
                    </a>
                  </div>                    
                  <div className="col-lg-6 text-right">
                    <a style={{cursor:'pointer'}} onClick={() => setAddingCharge(true)} >Add Product</a>
                  </div>
                </div>                
                <HeaderRow labels={['', '', 'Qty', 'Cost', 'Sale Price', 'Total']} />
                {props.chargeCategories && Object.entries(props.chargeCategories).map(([key, value]) => {
                  return (<ChargeCategory key={key} category={key} items={value} disabled={disabled} update={props.updateCharge} tryConvert={tryConvert} type="charge" />)
                })}
                <div className="row">
                  <div className="col-lg-12">
                    <hr style={{borderTop:'4px solid #e9edef', marginTop:'30px', marginBottom:'20px'}} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Sum Totals</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-10"></div>                
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Price:</p>
                    <NumberFormat
                      value={props.chargesOnlyTotal}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Cost:</p>
                    <NumberFormat
                      value={chargesOnlyExpense}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />                    
                  </div>
                </div>                
              </ModernCard>
            </div>
          </div> 
        </div>
        <div role="tabpanel" className="tab-pane" id="projectlabor">
          <div className="row">
              <div className="col-lg-12">
                <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                <div className="row" style={{paddingBottom:'15px'}}>
                  <div className="col-lg-6 text-left">
                    <a style={{cursor:'pointer'}} onClick={() => setSeeAllPServices(!seeAllPServices)} >
                      {seeAllPServices ? 'Hide all' : 'Show all'}
                    </a>
                  </div>                    
                  <div className="col-lg-6 text-right">
                    {/* <a style={{cursor:'pointer'}} onClick={} >Add Labor</a> */}
                  </div>
                </div>                    
                  <HeaderRow labels={['', '', 'Qty', 'Hours', 'Total Hours']} />
                  {props.projectServiceCategories && Object.entries(props.projectServiceCategories).map(([key, value]) => {
                    return (<ProjectServiceCategory key={key} category={key} items={value} disabled={disabled} update={props.updateProjectService} tryConvert={tryConvert} burdenRate={props.burdenRate} billRate={props.billRate} type="project_service" />)
                  })}
                {/* {props.projectServices.map((s) => <ProjectService service={s} tryConvert={tryConvert}  key={s.id} disabled={disabled} burdenRate={props.burdenRate} billRate={props.billRate} updateProjectService={props.updateProjectService} />)} */}
                {/* <div className="row">
                  <div className="col-lg-6"></div>
                  <div className="col-lg-2" style={{fontWeight:'bold', color:'black', fontSize:'16px'}}>Total:</div>
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <NumberFormat
                      value={props.projectHours}
                      displayType='text'
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                    />
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-lg-12">
                    <hr style={{borderTop:'4px solid #e9edef', marginTop:'30px', marginBottom:'20px'}} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Sum Totals</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8"></div>              
                  <div className="col-lg-2" style={{color:'black', fontSize:'16px', paddingBottom:'15px'}}>
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Hours:</p>
                    <NumberFormat
                      value={props.projectHours}
                      displayType='input'
                      disabled={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />                    
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Price:</p>
                    <NumberFormat
                      value={projectLaborRevenue}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />
                    <p style={{fontWeight:'bold', color:'black', fontSize:'14px'}}>Cost:</p>
                    <NumberFormat
                      value={projectLaborExpense}
                      displayType='input'
                      disabled={true}
                      prefix={'$ '}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      className="form-control"
                    />                    
                  </div>
                </div>
                </ModernCard>
              </div>
            </div>    
        </div>        
      </div>             
    </div>    
  )
}

function ProductCategory(props) {
  const [show, setShow] = useState(false);
  const active = countActiveItems(props.items)
  const { 
    seeAllProducts
  } = useQuote()

  useEffect(() => {
    setShow(seeAllProducts)
  }, [seeAllProducts])

  return (
    <div className="row">
      <div className="col-md-12">
        <a onClick={() => setShow(!show)} style={{cursor:'pointer'}}>
          <h3>
            {props.category} <small style={{color:'black'}}>({active}/{props.items.length})</small>
            {show ? <i className="fa fa-minus" style={{fontSize:'17px', marginLeft:'8px'}} /> : <i className="fa fa-plus" style={{fontSize:'17px', marginLeft:'8px'}} />}
          </h3>
          
        </a>
      </div>
      <div className="col-md-12" style={{display: show ? 'initial' : 'none'}}>
        {props.items.map((p) => <Product product={p} tryConvert={props.tryConvert} updateProduct={props.update} key={p.id}  disabled={props.disabled} />)}
      </div>
    </div>
  )
}

function ServiceCategory(props) {
  const [show, setShow] = useState(false);
  const active = countActiveItems(props.items)
  const { 
    seeAllServices
  } = useQuote()

  useEffect(() => {
    setShow(seeAllServices)
  }, [seeAllServices])
  return (
    <div className="row">
      <div className="col-md-12">
        <a onClick={() => setShow(!show)} style={{cursor:'pointer'}}>
          <h3>
            {props.category} <small style={{color:'black'}}>({active}/{props.items.length})</small>
            {show ? <i className="fa fa-minus" style={{fontSize:'17px', marginLeft:'8px'}} /> : <i className="fa fa-plus" style={{fontSize:'17px', marginLeft:'8px'}} />}
          </h3>
        </a>
      </div>
      <div className="col-md-12" style={{display: show ? 'initial' : 'none'}}>
        {props.items && props.items.map((s) => <Service service={s} tryConvert={props.tryConvert} updateService={props.update} key={s.id} disabled={props.disabled} burdenRate={props.burdenRate} billRate={props.billRate} />)}
      </div>
    </div>
  )
}

function ProjectServiceCategory(props) {
  const [show, setShow] = useState(false);
  const active = countActiveItems(props.items)
  const { 
    seeAllPServices
  } = useQuote()

  useEffect(() => {
    setShow(seeAllPServices)
  }, [seeAllPServices])
  return (
    <div className="row">
      <div className="col-md-12">
        <a onClick={() => setShow(!show)} style={{cursor:'pointer'}}>
          <h3>
            {props.category} <small style={{color:'black'}}>({active}/{props.items.length})</small>
            {show ? <i className="fa fa-minus" style={{fontSize:'17px', marginLeft:'8px'}} /> : <i className="fa fa-plus" style={{fontSize:'17px', marginLeft:'8px'}} />}
          </h3>
          
        </a>
      </div>
      <div className="col-md-12" style={{display: show ? 'initial' : 'none'}}>
        {props.items && props.items.map((s) => <ProjectService service={s} tryConvert={tryConvert}  key={s.id} disabled={props.disabled} burdenRate={props.burdenRate} billRate={props.billRate} updateProjectService={props.update} />)}
      </div>
    </div>
  )
}

function ChargeCategory(props) {
  const [show, setShow] = useState(false);
  const active = countActiveItems(props.items)
  const { 
    seeAllCharges
  } = useQuote()

  useEffect(() => {
    setShow(seeAllCharges)
  }, [seeAllCharges])
  return (
    <div className="row">
      <div className="col-md-12">
        <a onClick={() => setShow(!show)} style={{cursor:'pointer'}}>
          <h3>
            {props.category} <small style={{color:'black'}}>({active}/{props.items.length})</small>
            {show ? <i className="fa fa-minus" style={{fontSize:'17px', marginLeft:'8px'}} /> : <i className="fa fa-plus" style={{fontSize:'17px', marginLeft:'8px'}} />}
          </h3>
          
        </a>
      </div>
      <div className="col-md-12" style={{display: show ? 'initial' : 'none'}}>
        {props.items && props.items.map((c) => <Charge charge={c} tryConvert={props.tryConvert} updateCharge={props.update} key={c.id} disabled={props.disabled} />)}
      </div>
    </div>
  )
}


interface serviceProps{
  service: {
    id: number;
    name: string;
    default_hours: string;
    pay_rate: string;
    billable_rate:string;
    margin: string;
    created_at:string;
    updated_at:string;
    user_id:number;
    qty?:string;
    total?:string;
    notes?:string;
    thumbnail?:string;
    // updated payRate & billRate from organization settings 
    // instead of being individual per service.
  }
  tryConvert: Function;
  updateService: Function;
  disabled:boolean;
  burdenRate:number;
  billRate:number;
}

function Service(props:serviceProps){
  const initQty = props.service.qty == undefined ? '0' : props.service.qty
  const initTotal = props.service.total == undefined ? '0' : props.service.total
  const initNotes = props.service.notes == undefined ? '' : props.service.notes
  const [burdenRate, setBurdenRate] = useState(props.burdenRate)
  const [billRate, setBillRate] = useState(props.billRate) 
  const [qty, setQty] = useState(initQty)
  const [hours, setHours] = useState(props.service.default_hours)
  const [total, setTotal] = useState(initTotal)
  const [showNotes, setShowNotes] = useState(false)
  const [notes, setNotes] = useState(initNotes)

  useEffect(() => {
    let numbers = tryConvert([billRate, qty, hours])
    if(numbers){
      let product = numbers.reduce((a,b) => a*b)
      setTotal(product.toString())
    }
  }, [billRate, qty, hours])

  useEffect(() => {
    let service = props.service
    service.pay_rate = burdenRate.toString()
    service.billable_rate = billRate.toString()
    service.qty = qty
    service.default_hours = hours
    service.total = total
    service.notes = notes
    props.updateService(props.service.id, service)
  }, [burdenRate, billRate, qty, hours, total, notes])

  // forces local state burden and bill rates to update if props change.
  useEffect(() => {
    setBurdenRate(props.burdenRate)
    setBillRate(props.billRate)
  }, [props.burdenRate, props.billRate])   


  useEffect(() => {
    if(notes.length > 0){
      setShowNotes(true)
    }
  }, [])

  return (
    <>
    <div className="row">
      <LabelCol 
        label={props.service.name} 
        cost={burdenRate.toString()} 
        sale={billRate.toString()} 
        toggleNotes={() => {
          setShowNotes(!showNotes)
        }}
        notes={notes}
      />
      {/* <InputCol value={burdenRate.toString()} change={(values) => setBurdenRate(values.value)} prefix="$" disabled={props.disabled} />
      <InputCol value={billRate.toString()} change={(values) => setBillRate(values.value)} prefix="$" disabled={props.disabled} /> */}
      <InputCol value={qty} change={(values) => setQty(values.value)} decimalPlace={0} disabled={props.disabled} />
      <InputCol value={hours} change={(values) => setHours(values.value)} disabled={props.disabled} />
      <InputCol value={total} readOnly={true} prefix="$"  disabled={props.disabled} />
    </div>
    <div className="row" style={{paddingBottom:'20px'}}>
      <div className="col-lg-12">
        {showNotes && (
          <textarea className="form-control" rows={3} disabled={props.disabled} onChange={(e) => setNotes(e.target.value)} defaultValue={notes} placeholder="add your item notes here..">
          </textarea>
        )}
      </div>
    </div>
    {props.service.thumbnail && (
      <div className="row" style={{paddingBottom:'20px'}}>
        <div className="col-lg-2">
          <div className="text-center">
            <img src={props.service.thumbnail} style={{height:'100px'}} className="img-responsive"/>
          </div>
        </div>
      </div>
    )}
    </>
  )
}


interface projectserviceProps{
  service: {
    id: number;
    name: string;
    default_hours: string;
    pay_rate: string;
    billable_rate:string;
    margin: string;
    created_at:string;
    updated_at:string;
    user_id:number;
    qty?:string;
    total?:string;
    total_hours?:string;
    notes?:string;
    // updated payRate & billRate from organization settings 
    // instead of being individual per service.
  }
  tryConvert: Function;
  updateProjectService: Function;
  disabled:boolean;
  burdenRate?:number;
  billRate?:number;
}

function ProjectService(props:projectserviceProps){
  const initQty = props.service.qty == undefined ? '0' : props.service.qty
  const initNotes = props.service.notes == undefined ? '' : props.service.notes
  const [burdenRate, setBurdenRate] = useState(props.burdenRate)
  const [billRate, setBillRate] = useState(props.billRate) 
  const [qty, setQty] = useState(initQty)
  const [hours, setHours] = useState(props.service.default_hours)
  const [totalHours, setTotalHours] = useState(0)
  const [showNotes, setShowNotes] = useState(false)
  const [notes, setNotes] = useState(initNotes)

  useEffect(() => {
    let numbers = tryConvert([qty, hours])
    if(numbers){
      let product = numbers.reduce((a,b) => a*b)
      setTotalHours(product.toString())
    }
  }, [qty, hours])

  useEffect(() => {
    let service = props.service
    service.qty = qty
    service.default_hours = hours
    service.total_hours = totalHours.toString()
    service.billable_rate = props.billRate.toString()
    service.pay_rate = props.burdenRate.toString()
    service.notes = notes
    props.updateProjectService(props.service.id, service)
  }, [qty, hours, totalHours, notes])

  useEffect(() => {
    if(notes.length > 0){
      setShowNotes(true)
    }
  }, [])  

  return (
    <>
    <div className="row">
      <LabelCol 
        label={props.service.name} 
        cost={burdenRate.toString()} 
        sale={billRate.toString()} 
        toggleNotes={() => {
          setShowNotes(!showNotes)
        }}
        notes={notes}        
      />
      <InputCol value={qty} change={(values) => setQty(values.value)} decimalPlace={0} disabled={props.disabled} />
      <InputCol value={hours} change={(values) => setHours(values.value)} disabled={props.disabled} />
      <InputCol value={totalHours.toString()} readOnly={true}  disabled={props.disabled} />
    </div>
    <div className="row" style={{paddingBottom:'20px'}}>
      <div className="col-lg-12">
        {showNotes && (
          <textarea className="form-control" rows={3} disabled={props.disabled} onChange={(e) => setNotes(e.target.value)} defaultValue={notes} placeholder="add your item notes here..">
          </textarea>
        )}
      </div>
    </div>    
    </>
  )
}

interface productProps{
  product: {
    id:number;
    name: string;
    cost_price: string;
    sale_price:string;
    margin:string;
    created_at:string;    
    updated_at:string;
    user_id:number;
    qty?:string;
    total?:string;      
    notes?:string; 
    thumbnail?:string;
  }
  tryConvert: Function;
  updateProduct: Function;
  disabled:boolean;
}

function Product(props:productProps){
  const initQty = props.product.qty == undefined ? '0' : props.product.qty
  const initTotal = props.product.total == undefined ? '0' : props.product.total
  const initNotes = props.product.notes == undefined ? '' : props.product.notes
  const [costPrice, setCostPrice] = useState(props.product.cost_price)
  const [salePrice, setSalePrice] = useState(props.product.sale_price)
  const [qty, setQty] = useState(initQty)
  const [total, setTotal] = useState(initTotal)
  const [showNotes, setShowNotes] = useState(false)
  const [notes, setNotes] = useState(initNotes) 

  useEffect(() => {
    let numbers = tryConvert([salePrice, qty])
    if(numbers){
      let product = numbers.reduce((a,b) => a*b)
      setTotal(product.toString())
    }
  }, [salePrice, qty])
  
  useEffect(() => {
    let product = props.product
    product.cost_price = costPrice
    product.sale_price = salePrice
    product.qty = qty
    product.total = total
    product.notes = notes
    props.updateProduct(props.product.id, product)
  }, [costPrice, salePrice, qty, total, notes])
  
  useEffect(() => {
    if(notes.length > 0){
      setShowNotes(true)
    }
  }, [])

  return(
    <>
    <div className="row">
      <LabelCol 
        label={props.product.name} 
        cost={costPrice} sale={salePrice} 
        toggleNotes={() => {
          setShowNotes(!showNotes)
        }}
        notes={notes}
      />
      <InputCol value={qty} change={(values) => setQty(values.value)} decimalPlace={0} disabled={props.disabled} />
      <InputCol value={costPrice} change={(values) => setCostPrice(values.value)} prefix="$" disabled={props.disabled} />
      <InputCol value={salePrice} change={(values) => setSalePrice(values.value)} prefix="$" disabled={props.disabled} />
      <InputCol value={total} readOnly={true} prefix="$" disabled={props.disabled} />
    </div>
    <div className="row" style={{paddingBottom:'20px'}}>
      <div className="col-lg-12">
        {showNotes && (
          <textarea className="form-control" rows={3} disabled={props.disabled} onChange={(e) => setNotes(e.target.value)} defaultValue={notes} placeholder="add your item notes here..">
          </textarea>
        )}
      </div>
    </div>
    {props.product.thumbnail && (
      <div className="row" style={{paddingBottom:'20px'}}>
        <div className="col-lg-2">
          <div className="text-center">
            <img src={props.product.thumbnail} style={{height:'100px'}} className="img-responsive"/>
          </div>
        </div>
      </div>
    )}
    </>
  )
}

interface chargeProps{
  charge: {
    id:number;
    name: string;
    cost_price: string;
    sale_price:string;
    margin:string;
    created_at:string;
    updated_at:string;
    user_id:number;
    qty?:string;
    total?:string;
    notes?:string;
    thumbnail?:string;
  }
  tryConvert: Function;
  updateCharge: Function;
  disabled:boolean;
}

function Charge(props:chargeProps){
  const initQty = props.charge.qty == undefined ? '0' : props.charge.qty
  const initTotal = props.charge.total == undefined ? '0' : props.charge.total
  const initNotes = props.charge.notes == undefined ? '' : props.charge.notes
  const [costPrice, setCostPrice] = useState(props.charge.cost_price)
  const [salePrice, setSalePrice] = useState(props.charge.sale_price)
  const [qty, setQty] = useState(initQty)
  const [total, setTotal] = useState(initTotal)  
  const [showNotes, setShowNotes] = useState(false)
  const [notes, setNotes] = useState(initNotes)  

  useEffect(() => {
    let numbers = tryConvert([salePrice, qty])
    if(numbers){
      let product = numbers.reduce((a,b) => a*b)
      setTotal(product.toString())
    }
  }, [salePrice, qty])

  useEffect(() => {
    let charge = props.charge
    charge.cost_price = costPrice
    charge.sale_price = salePrice
    charge.qty = qty
    charge.total = total
    charge.notes = notes
    props.updateCharge(props.charge.id, charge)
  }, [costPrice, salePrice, qty, total, notes])

  useEffect(() => {
    if(notes.length > 0){
      setShowNotes(true)
    }
  }, [])

  return(
    <>
    <div className="row">
      <LabelCol 
        label={props.charge.name} 
        cost={costPrice} 
        sale={salePrice} 
        toggleNotes={() => {
          setShowNotes(!showNotes)
        }}
        notes={notes}
      />
      <InputCol value={qty} change={(values) => setQty(values.value)} decimalPlace={0} disabled={props.disabled} />
      <InputCol value={costPrice} change={(values) => setCostPrice(values.value)} prefix="$" disabled={props.disabled} />
      <InputCol value={salePrice} change={(values) => setSalePrice(values.value)} prefix="$" disabled={props.disabled} />
      <InputCol value={total} readOnly={true} prefix="$" disabled={props.disabled} />
    </div>
    <div className="row" style={{paddingBottom:'20px'}}>
      <div className="col-lg-12">
        {showNotes && (
          <textarea className="form-control" rows={3} disabled={props.disabled} onChange={(e) => setNotes(e.target.value)} defaultValue={notes} placeholder="add your item notes here..">
          </textarea>
        )}
      </div>
    </div>
    {props.charge.thumbnail && (
      <div className="row" style={{paddingBottom:'20px'}}>
        <div className="col-lg-2">
          <div className="text-center">
            <img src={props.charge.thumbnail} style={{height:'100px'}} className="img-responsive"/>
          </div>
        </div>
      </div>
    )}    
    </>
  )
}

interface PLRProps{
  qty:number;
  cost_price:number;
  sale_price:number;
}

function ProjectLaborRow(props:PLRProps){
  return (
    <div className="row">
      <LabelCol label="Project Labor" cost={'0'} sale={'0'} />
      <InputCol value={props.qty.toString()} disabled={true} />
      <InputCol value={props.cost_price.toString()}  prefix="$" disabled={true} />
      <InputCol value={props.sale_price.toString()}  disabled={true} />      
    </div>
  )
}

interface InputColProps{
  value: string;
  change?: Function;
  readOnly?: boolean
  decimalPlace?: number;
  prefix?: string;
  disabled: boolean;
}

function InputCol(props:InputColProps){
  const decimals = props.decimalPlace == undefined ? 2 : props.decimalPlace
  const read = props.readOnly == undefined ? false : props.readOnly
  const prefix = props.prefix == undefined ? '' : props.prefix
  return (
    <div className="col-lg-2">
      <NumberFormat
        value={props.value}
        displayType={'input'} 
        fixedDecimalScale={true} 
        decimalScale={decimals}
        prefix={prefix}
        className='form-control'
        onValueChange={(values) => props.change(values) }
        readOnly={read}
        disabled={props.disabled}
        thousandSeparator={true}
        isAllowed={(values) => {
          if(values.floatValue == undefined){
            return false
          }
          if(values.floatValue < 0){
            return false
          }
          return true
        }}
      />        
    </div>
  )
}

interface LabelColProps {
  label:string;
  cost:string;
  sale:string
  toggleNotes?:Function;
  notes?:string;
}

function LabelCol(props:LabelColProps){
  return (
    <div className="col-lg-4">
      <p 
        className="goods-name" 
        onClick={() => {
          props.toggleNotes()
        }}
        style={{cursor: 'pointer'}}
        title="add notes"
      >
        <i className="fa fa-pencil-square-o" style={{marginRight:'5px'}} />{props.label}
      </p>
      <ProfitBar cost={parseFloat(props.cost)} revenue={parseFloat(props.sale)} />
    </div>
  )
}

interface headerRowProps {
  labels: Array<string>
}

function HeaderRow(props:headerRowProps){
  return (
    <div className="row labels">
      {props.labels.map((label, i) => <div className="col-lg-2" key={i}>{label}</div>)}
    </div>
  )
}


export default QuoteForm


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteForm.tsx